module.exports = __webpack_public_path__ + "img/frame (93).73dec660.jpg";